var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPendingActions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99957 6.16602L11.8402 10.0066L15.6807 13.8472L9.1022 16.5852L2.52368 19.3231L5.26161 12.7446L7.99957 6.16602Z",
    fill: "#F1B31C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 10.6943L7.85042 6.31543L5.00845 12.998L2.1665 19.6805L12.2222 10.6943Z",
    fill: "#FCEA2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65168 13.8369L8.03173 17.217L6.34171 17.9049L3.95923 15.5224L4.65168 13.8369Z",
    fill: "#EA5A47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29907 16.881L6.3416 17.9049L8.03162 17.2169L6.56468 15.75L5.29907 16.881Z",
    fill: "#D22F27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35687 9.82715L8.40306 11.8733L11.9778 15.4481L10.0611 16.323L7.56412 13.826L5.5459 11.8078L6.35687 9.82715Z",
    fill: "#EA5A47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10864 14.3701L10.0613 16.3228L11.978 15.4478L9.58286 13.0527L8.10864 14.3701Z",
    fill: "#D22F27"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5069 12.6585C17.8444 12.6585 18.118 12.3889 18.118 12.0563C18.118 11.7237 17.8444 11.4541 17.5069 11.4541C17.1694 11.4541 16.8958 11.7237 16.8958 12.0563C16.8958 12.3889 17.1694 12.6585 17.5069 12.6585Z",
    fill: "#D22F27"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4234 6.24246C18.7609 6.24246 19.0345 5.97285 19.0345 5.64027C19.0345 5.30769 18.7609 5.03809 18.4234 5.03809C18.0859 5.03809 17.8123 5.30769 17.8123 5.64027C17.8123 5.97285 18.0859 6.24246 18.4234 6.24246Z",
    fill: "#F1B31C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25686 5.01981C9.59437 5.01981 9.86798 4.7502 9.86798 4.41762C9.86798 4.08504 9.59437 3.81543 9.25686 3.81543C8.91936 3.81543 8.64575 4.08504 8.64575 4.41762C8.64575 4.7502 8.91936 5.01981 9.25686 5.01981Z",
    fill: "#8967AA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8811 8.16309C18.851 8.31486 18.7963 8.46467 18.7154 8.60749C18.2962 9.34769 17.3334 9.61857 16.5649 9.21249",
    className: "iconStroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4802 13.9452L15.5316 13.9966L8.84906 16.8386L2.1665 19.6805L5.00848 12.998L7.85042 6.31543",
    className: "iconStroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88354 6.34863L11.691 10.156L15.4801 13.9452",
    className: "iconStroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6146 9.24498C16.4871 9.15735 16.3434 9.08823 16.1858 9.0424C15.3689 8.80483 14.4904 9.28278 14.2234 10.1099",
    className: "iconStroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85034 6.31543L7.88356 6.34864",
    className: "iconStroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2055 2.25098C14.2772 2.38808 14.3285 2.53912 14.3551 2.70106C14.4929 3.54051 13.913 4.35537 13.0598 4.5211",
    className: "iconStroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1183 4.51465C12.964 4.52638 12.8087 4.56271 12.6572 4.62587C11.8721 4.95321 11.4876 5.87651 11.7985 6.68813",
    className: "iconStroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPendingActions);
export default __webpack_public_path__ + "static/media/noPendingActions.8215eebc52a35f4ad70fa7959b0b5580.svg";
export { ForwardRef as ReactComponent };